import { IntegrationsModule } from '../modules/integrations';
import { StartupSubPageShell } from './StartupSubPageShell';

export default function StartupIntegrationsPage(): JSX.Element {
  return (
    <StartupSubPageShell activeSection="integrations">
      {() => <IntegrationsModule />}
    </StartupSubPageShell>
  );
}
